<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				<span class="text-wrap">{{ subtitle }}</span>
			</v-card-subtitle>
		</v-card-item>
		<z-photo ref="photo"
			v-model="item.files"
			:required="item.required"
			:min="item.min"
			:max="item.max"
			:visible="visible"
			:changed="item.changed"
			@change="item.changed=true"
		></z-photo>

		<v-card-text v-html="text"></v-card-text>
	</v-card>
</template>

<script>
//import { mapGetters, mapActions } from 'vuex'
import mixin from '../components/mixin/main'
import zPhoto from '@/components/banners/Photo4'

export default {
	name: 'Component::Document',
	mixins: [mixin],
	components: { zPhoto },

	methods: {
		validate() {
			return this.$refs.photo?.validate()
		}
	},
}
</script>
